import React from 'react'
import { createRoot } from 'react-dom/client';
import 'antd/dist/reset.css'
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle.min.js";
import App from './App';
import * as serviceWorker from './serviceWorker';
import "./index.css";
import { HelmetProvider } from "react-helmet-async";
import "./i18n";

const container = document.getElementById('root');
const root = createRoot(container); // createRoot(container!) if you use TypeScript
root.render(
    // <React.StrictMode>

    <HelmetProvider>
      <App />
    </HelmetProvider>
      
    // </React.StrictMode>
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
